(() => {
  'use strict';
  
  const SECTION = document.querySelector('.nextdev--multicolumn-reviews');
  const SWIPER = SECTION.querySelector('.swiper');
  const videos = SECTION.querySelectorAll('video[autoplay]');

  const swiperInstance = new Swiper(SWIPER, {
    slidesPerView: 'auto',
    spaceBetween: 12,
    slidesPerGroup: 1,
    
    mousewheel: {
      forceToAxis: true
    },

    pagination: {
      el: '.swiper--multicolumn-reviews-pagination'
    },

    navigation: {
      prevEl: '.swiper--multicolumn-reviews-button-prev',
      nextEl: '.swiper--multicolumn-reviews-button-next'
    },

    breakpoints: {
      750: {
        slidesPerGroup: 3
      }
    }
  });

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:block:select', (event) => {
      const blockId = event.detail.blockId;

      const slideIndex = [...SWIPER.querySelectorAll('.swiper-slide')].findIndex(
        el => el.dataset.blockId === blockId
      );
      
      if (slideIndex !== -1) {
        swiperInstance.slideTo(slideIndex);
      }
    });
  }

  if (videos.length > 0) {
    const observerOptions = {
      threshold: 0.5 // 50% of the video must be visible
    };

    const handleIntersection = (entries) => {
      entries.forEach(entry => {
        const video = entry.target;
        if (entry.isIntersecting) {
          video.play().catch(err => {
            console.warn('Video play failed:', err);
          });
        } else {
          video.pause();
        }
      });
    };
  
    const observer = new IntersectionObserver(handleIntersection, observerOptions);
  
    videos.forEach(video => {
      video.muted = true;
      observer.observe(video);
    });
  }
})();
